// El candado de versión de la app instalada (pedido de Sebastián del
// 20-oct-2026: poder exigir que la gente actualice). Puro y sin red: compara la
// versión que trae el teléfono con la mínima que dice el servidor
// (api/app-config) y decide si se pide actualizar.
//
// Tres reglas, todas hacia NO dejar a nadie fuera por error:
//   - Si falta un dato o viene raro, no se exige nada (una versión mal escrita
//     en Vercel no puede bloquear a todos).
//   - Nunca a mitad de turno: con un turno abierto, del enfermero o del TENS,
//     se espera a la próxima apertura (la regla de no interrumpir un
//     registro). App lo decide solo con la sesión resuelta y con una respuesta
//     nueva del servidor, nunca con una versión mínima guardada.
//   - Lo registrado sigue en el teléfono al actualizar; la pantalla lo dice.
//
// Ojo: solo funciona desde la versión que trae este archivo. Una app más vieja
// no sabe pedir actualizar; a esa gente solo la alcanza la actualización
// automática de la tienda o el correo.

const VERSION_RE = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;

function partes(v) {
  const m = typeof v === 'string' ? v.trim().match(VERSION_RE) : null;
  return m ? m.slice(1).map(Number) : null;
}

// -1, 0 o 1; null si alguna no es una versión "1.4.0".
export function compararVersiones(a, b) {
  const x = partes(a);
  const y = partes(b);
  if (!x || !y) return null;
  for (let i = 0; i < 3; i++) {
    if (x[i] !== y[i]) return x[i] < y[i] ? -1 : 1;
  }
  return 0;
}

export function requiereActualizar(instalada, minima) {
  return compararVersiones(instalada, minima) === -1;
}

// La decisión entera, para que App solo la lea.
export function debePedirActualizar({ instalada, minima, hayTurno = false } = {}) {
  if (hayTurno) return false;
  return requiereActualizar(instalada, minima);
}

export const URL_TIENDA = {
  android: 'https://play.google.com/store/apps/details?id=cl.mipae.app',
  ios: 'https://apps.apple.com/cl/app/mipae/id6807250810',
};
